/*
 * @Author       : 萝卜兄台
 * @Date         : 2023-03-01 13:34:24
 * @LastEditors  : 萝卜兄台\thund leili995997651@qq.com
 * @LastEditTime : 2023-05-30 16:25:59
 * @FilePath     : \gas_station_platform_web\src\utils\static.ts
 * @Description  : 字典
 */

/** 类型 */
const logType = [
    { label: "全部", value: "" },
    { label: "管理员", value: "admin" },
    { label: "客户端", value: "web" },
    { label: "算法服务", value: "task" },
    { label: "异常", value: "ERROR" },
]
/** 纠错类型 */
const rtType = [
    { label: '目标识别错误', value: 'ERROR' },
    { label: '设置别名', value: 'ALIAS' },
]
/** 颜色 */
const colorList = [
    '#30e0e0',
    '#ff7f50',
    '#87cefa',
    '#da70d6',
    '#32cd32',
    '#6495ed',
    '#ff69b4',
    '#ba55d3',
    '#cd5c5c',
    '#ffa500',
    '#40e0d0',
    '#1e90ff',
    '#ff6347',
    '#7b68ee',
    '#00fa9a',
    '#ffd700',
    '#6699FF',
    '#ff6666',
    '#3cb371',
    '#b8860b',

]
/** 目标类型 */
const targetType = [
    { label: '可见光', value: 'KJG' },
    { label: 'SAR', value: 'SAR' },
    { label: '遥感', value: 'YG' },
    { label: '红外', value: 'HW' },
]

const taskType = [
    { label: "常规任务", value: "NORMAL" },
    { label: "定时任务", value: "AUTOMATIC" },
]
/** 应用场景 */
const modelType = [
    { label: "高精度", value: "PRECISION" },
    { label: "低时延", value: "LOWLATENT" },
    { label: "平衡", value: "BALANCE" },
    { label: "边缘", value: "EDGE" },
    { label: "终端", value: "TERMINAL" },
]
/** 模型训练 任务状态 */
const taskStatusData = [
    { label: '全部', value: '' },
    { label: '排队中', value: 'QUEUING' },
    { label: '进行中', value: 'TRAINING' },
    { label: '已完成', value: 'DONE' },
]
/** 训练状态 */
const trainingStatus = [
    { label: '排队中', value: 'QUEUING', color: '#409EFF' },
    { label: '失败', value: 'FAIL', color: '#F56C6C' },
    { label: '训练中', value: 'TRAINING', color: '#409EFF' },
    { label: '暂停', value: 'PAUSE', color: '#ffba00' },
    { label: '已停止', value: 'STOP', color: '#E6A23C' },
    { label: '已完成', value: 'DONE', color: '#67C23A' },
]
/** 计算平台 */
const computingPlatform = [
    { label: 'GPU', value: 'GPU' },
    { label: 'CPU', value: 'CPU' },
    { label: 'HISILICON ASIC', value: 'HISILICON' },
    { label: 'ONLINE', value: 'ONLINE' },
]
/** 人机协同使用的modelType */
const synergyModelType = [
    { label: '通用', value: 'GENERAL' },
    { label: '人物', value: 'PERSON' },
    { label: '武器', value: 'WEAPON' },
    { label: '舰船', value: 'SHIP' },
    { label: '坦克', value: 'TANK' },
    { label: '飞机', value: 'PLANE' },
]

const exportStatus = [
    { label: '失败', value: 'FAIL' },
    { label: '正在导出', value: 'EXPORTING' },
    { label: '已完成', value: 'DONE' },
]
/** 设备运行状态 */
const runStatus = [
    { label: '正常', value: 'NORMAL', color: '#87d068' },
    { label: '告警', value: 'ALERT', color: '#2db7f5' },
    { label: '严重', value: 'SERIOUS', color: '#1890ff' },
    { label: '致命', value: 'DEADLY', color: '#f50' },
]
export default {
    logType,
    rtType,
    colorList,
    targetType,
    taskType,
    modelType,
    taskStatusData,
    computingPlatform,
    trainingStatus,
    synergyModelType,
    exportStatus,
    runStatus
}